import React from "react";

import { useSelector } from "react-redux";

import { Autocomplete, getOptionAsValue } from "components/Form/FormikControls";

import { EMPTY_ARRAY } from "lib";

import { getCurrentSpeciesId } from "selectors";

import {
  SpeciesAttribute,
  useGetAttributeOptions,
} from "hooks/useGetAttributeOptions";

export const SexField = ({
  name,
  dataTour,
  label,
  disabled,
  deploymentId,
  speciesId,
  modelIds = EMPTY_ARRAY,
}) => {
  const saleSpeciesId = useSelector(getCurrentSpeciesId);

  const options = useGetAttributeOptions(
    SpeciesAttribute.SEX,
    speciesId || saleSpeciesId,
    deploymentId,
  );

  return (
    <Autocomplete
      name={name}
      dataTour={dataTour}
      label={label}
      options={options}
      getOptionValue={getOptionAsValue}
      disabled={disabled}
      modelIds={modelIds}
      missingMLAFieldsWarningEnabled
    />
  );
};
